module.exports = __webpack_public_path__ + "img/rs_baby2.ae8b5b65.jpg";